/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2017-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

angular.module('bulbApp.contentEditorModule')
  .controller('ImageCarouselBlockController', [
    '$',
    '$scope',
    '$timeout',
    '$translate',
    'Restangular',
    'BulbBrowserService',
    'BulbImageCarouselService',
    'CONFIG',
    'CONTENT_EDITOR',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    ImageCarouselBlockController,
  ]);

function ImageCarouselBlockController(
  $,
  $scope,
  $timeout,
  $translate,
  Restangular,
  BulbBrowserService,
  BulbImageCarouselService,
  CONFIG,
  CONTENT_EDITOR,
) {
  const that = this;

  // Image carousels will take up the whole width of the page, just as videos do
  this.pageContentMaxWidth = CONFIG.page.content.max.width;
  this.thumbnailSlickInstance = null;
  this.contentBlockCtrl = $scope.contentBlockCtrl;

  // Used to determine how to render the image carousel
  this.mode = $scope.pageViewCtrl.page.mode;
  this.isMobile = BulbBrowserService.isIOSMobile() || BulbBrowserService.isAndroid();

  // Thumbnail images array that will display when the user drags the image carousel
  this.draggableCarouselThumbnails = this.contentBlockCtrl.contentBlock.carouselImages;
  $scope.$watch('this.contentBlockCtrl.contentBlock.carouselImages', (newValues, oldValues) => {
    if (newValues !== oldValues) {
      that.draggableCarouselThumbnails = newValues;
    }
  });

  // Event listeners for carousel image manipulations
  $scope.$on('added-carousel-image', (event, index) => {
    that.event = event.name;
    that.currentIndex = index;
  });

  $scope.$on('removed-carousel-image', (event, index) => {
    that.event = event.name;
    that.currentIndex = index;
  });

  $scope.$on('cropped-carousel-image', (event, index) => {
    that.event = event.name;
    that.currentIndex = index;
  });

  $scope.$on('rotated-carousel-image', (event, index) => {
    that.event = event.name;
    that.currentIndex = index;
  });

  const deregisterCarouselDragHandler = $scope.$on('command-carousel-draggable', (event, data) => {
    // Only transition the state of the carousel that is currently selected
    if (data.selectedBlock.id === that.contentBlockCtrl.contentBlock.id) {
      if (that.slickConfigDisplayLoaded && that.slickConfigThumbnailsLoaded) {
        that.slickConfigDisplayLoaded = false;
        that.slickConfigThumbnailsLoaded = false;
        that.isDraggable = data.draggable;
      } else {
        that.slickConfigDisplayLoaded = true;
        that.slickConfigThumbnailsLoaded = true;
        // Explicitly set the isDraggable variable to false
        that.isDraggable = false;
      }

      that.contentBlockCtrl.contentBlockElement.click();
      data.contentEditorCtrl.insertBlockExtension.selectBlock(that.contentBlockCtrl.contentElement[0]);
    }
  });

  $scope.$on('command-carousel-draggable-drop', (event, data) => {
    // Only transition the state of the carousel that is currently selected
    if (data.selectedBlock.id === that.contentBlockCtrl.contentBlock.id) {
      // Update the reposition button
      const $repositionButton = $('.medium-editor-action-dragCarousel');
      $repositionButton.removeClass('bulb-carousel-draggable-selected');

      that.slickConfigDisplayLoaded = true;
      that.slickConfigThumbnailsLoaded = true;
      that.isDraggable = data.draggable;

      deregisterCarouselDragHandler();
    }
  });

  const deregisterWatchHandler = $scope.$watchCollection('contentBlockCtrl.contentBlock', () => {
    that.updateCarouselDimensions();
  });

  /**
   * Custom Auto save options for the carousel image caption
   * @type {{restId, customSave: ImageCarouselBlockController.autoSaveOptions.customSave}}
   */
  this.autoSaveOptions = {
    restId: this.contentBlockCtrl.page.unit.id,
    customSave: function customSave() {
      const patch = {
        carouselCaption: that.contentBlockCtrl.contentBlock.carouselImages[
          that.contentBlockCtrl.contentBlock.displayedImageIndex].caption,
        selectedImageIndex: that.contentBlockCtrl.contentBlock.displayedImageIndex,
      };
      return Restangular.one('units', $scope.contentBlockCtrl.page.unit.id)
        .one(
          CONTENT_EDITOR.BLOCK_PATHS[that.contentBlockCtrl.contentBlock.blockType],
          that.contentBlockCtrl.contentBlock.id,
        )
        .patch(patch);
    },
  };

  //= ===================================
  // Initial Slick initialization for displaying the current image
  //= ===================================
  this.slickConfigDisplayLoaded = true;
  this.slickDisplayConfig = {
    fade: true,
    arrows: true,
    asNavFor: `.slider-nav-${that.contentBlockCtrl.contentBlock.id}`,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    event: {
      init: function init(event, slick) {
        $timeout(() => {
          // For touch screens
          const $figcaption = $('figcaption');
          $figcaption.on('touchstart', function touchStart(e) {
            $(this).find('p').focus();
            e.preventDefault();
          });

          if (that.currentIndex === undefined) {
            that.contentBlockCtrl.contentBlock.displayedImageIndex = 0;
            slick.slickGoTo(0);
          } else if (that.event === 'added-carousel-image') {
            slick.slickGoTo((that.currentIndex + 1));
          } else if (that.event === 'removed-carousel-image') {
            slick.slickGoTo((that.currentIndex - 1));
            if (that.contentBlockCtrl.contentBlock.carouselImages.length === 1) {
              that.contentBlockCtrl.contentBlock.displayedImageIndex = 0;
            }
          } else if (that.event === 'cropped-carousel-image' || that.event === 'rotated-carousel-image') {
            slick.slickGoTo(that.currentIndex);
            that.contentBlockCtrl.contentBlock.displayedImageIndex = that.currentIndex;
          }
        });
        deregisterWatchHandler();
      },
      afterChange: function afterChange(event, slick, currentSlideIndex, nextSlideIndex) {
        that.contentBlockCtrl.contentBlock.displayedImageIndex = currentSlideIndex;
        $timeout(() => {
          BulbImageCarouselService.grabCurrentDisplaySlide(
            that.thumbnailSlickInstance,
            that.contentBlockCtrl.contentBlock.carouselImages[currentSlideIndex],
          );
        });
      },
    },
  };

  //= ===================================
  // Initial Slick initialization for thumbnails
  //= ===================================
  this.slickConfigThumbnailsLoaded = true;
  this.slickConfigThumbnailsDisplay = {
    dots: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
    centerMode: true,
    centerPadding: (!this.isMobile) ? '130px' : '',
    infinite: true,
    asNavFor: `.slider-for-${that.contentBlockCtrl.contentBlock.id}`,
    event: {
      init: function init(event, slick) {
        BulbImageCarouselService.checkSlickNoSlide(slick);
        that.thumbnailSlickInstance = slick;
        BulbImageCarouselService.grabCurrentThumbnailSlide(slick);
      },
    },
  };

  //= ===================================
  // Initial Slick initialization for displaying the current image for non-authors / view mode only
  //= ===================================
  this.slickConfigDisplayViewLoaded = true;
  this.slickDisplayViewConfig = {
    fade: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    event: {
      init: function init(event, slick) {
        that.contentBlockCtrl.contentBlock.displayedImageIndex = 0;
        // Modify the position fo the slick dots for render only version
        if (slick.$dots) {
          slick.$dots.css({
            top: that.height + CONTENT_EDITOR.CAROUSEL.SLICK_RENDER_DOTS_PADDING,
          });
        } else {
          $timeout(() => {
            $('figcaption').css({
              top: that.height - CONTENT_EDITOR.CAROUSEL.SLICK_RENDER_FIGCAPTION,
            });
          });
        }
        deregisterWatchHandler();
      },
      afterChange: function afterChange(event, slick, currentSlideIndex, nextSlideIndex) {
        that.contentBlockCtrl.contentBlock.displayedImageIndex = currentSlideIndex;
      },
    },
  };

  /**
   * Function that updates the carousel state after adding, removing, or manipulating a carousel image.
   * @param modifiedImageCarouselBlock The modifiedImageCarouselBlock sent back from the server
   */
  this.updateCarouselState = function updateCarouselState(modifiedImageCarouselBlock) {
    // To change slide content, you have to set ng-if to destroy and then init it again. That is
    // why we set the 'slickConfigDisplayLoaded' and 'slickConfigThumbnailsDisplay' to false and
    // then true after adding the new slide. This is how the angular-slick-library adds an image
    // to the carousel. It also renews the state of the carousel, saving it to the page correctly.
    this.slickConfigDisplayLoaded = false;
    this.slickConfigThumbnailsLoaded = false;

    angular.copy(modifiedImageCarouselBlock.plain(), that.contentBlockCtrl.contentBlock);

    $timeout(() => {
      that.slickConfigDisplayLoaded = true;
      that.slickConfigThumbnailsLoaded = true;
    });
  };

  //= ===================================
  // Initial ng-image-gallery initialization for displaying the image carousel for an anonymous user and non-
  // authors
  //= ===================================
  this.conf = {
    thumbnails: false,
    thumbSize: 80,
    inline: false,
    bubbleSize: 10, // This sets the dots width and height
    bgClose: true, // Close the fullscreen modal on click or touch
    bubbles: true, // I make them look like conventional thumbnails by overriding the css
    deletable: false,
    imgBubbles: false,
    piracy: true,
    imgAnim: 'fadeup',
  };

  // Carousel methods gateway is a communication gateway between your app and image gallery methods. It's a
  // JavaScript object which can be used to open or close the modal as well as change images inside gallery using
  // prev and next key.
  this.methods = {};
  this.openCarousel = function openCarousel() {
    this.methods.open();
  };

  // PreviewImages is a JavaScript array that contains objects with image url(s) of the images to be loaded into the
  // carousel.
  this.previewImages = [];

  // This is the callback function that gets called when the image carousel is opened in fullscreen mode for
  // non-authors.
  this.opened = function opened() {
    const $pageHeader = $('.bulb-page-header');
    $pageHeader.addClass('move-to-background');

    const $contentBlocksOnPage = $('content-block');
    // Set the z-index to -1, so they don't become displayed
    // over the fullscreen mode for image carousel.
    $contentBlocksOnPage.not(`content-block[id="${that.contentBlockCtrl.contentBlock.id}"]`).css({
      zIndex: '-1',
    });

    // Actually populating the previewImages array
    let counter = 0;
    that.contentBlockCtrl.contentBlock.carouselImages.forEach((carouselImage) => {
      const imageAsset = carouselImage.scaledImageAsset || carouselImage.fullImageAsset;
      const image = {
        id: imageAsset.id + counter,
        url: imageAsset.url,
        extUrl: imageAsset.url,
        thumbUrl: imageAsset.url,
        title: carouselImage.caption,

      };
      counter += 1;
      that.previewImages.push(image);
    });
  };

  // This is the callback function that gets called when the image carousel is closed in fullscreen mode for
  // non-authors.
  this.closed = function closed() {
    // Reset the size of the array to 0, that way on the open function, it doesn't populate the array with
    // duplicate images
    this.previewImages = [];

    const $pageHeader = $('.bulb-page-header');
    $pageHeader.removeClass('move-to-background');

    const $contentBlocksOnPage = $('content-block');
    // Delete the z-index property that was defined from the
    // "opened" callback.
    $contentBlocksOnPage.not(`content-block[id="${that.contentBlockCtrl.contentBlock.id}"]`).css({
      zIndex: '',
    });
  };

  // Function that gets called initially when the image-block gets converted to the image-carousel-block
  // or when the page is refreshed.
  // It sets up the width, height, and maxWidth of the image carousel on the page.
  this.updateCarouselDimensions = function updateCarouselDimensions() {
    const maxSize = CONFIG.page.content.max.width;
    const contentSize = $('.bulb-page-content').width();
    const contentScale = contentSize / maxSize;

    // Update the page content max width so that it fits correctly on all devices
    that.pageContentMaxWidth *= contentScale;

    const { carouselImages } = that.contentBlockCtrl.contentBlock;
    // Always base dimensions off the first image in the carousel
    const displayedImageAsset = carouselImages[0].scaledImageAsset || carouselImages[0].fullImageAsset;

    const imageWidth = displayedImageAsset.width;
    let imageHeight = displayedImageAsset.height;
    let imageScale = 1;
    let carouselMargin = '3.5em';

    // If we are displaying an image larger than the content maxWidth, scale it down to fix.  Typically, only
    // necessary when re-cropping an image, since other images fit within the content maxWidth.
    if (imageWidth > maxSize) {
      imageScale = maxSize / imageWidth;
      imageHeight *= imageScale;
    }

    if (this.isMobile) {
      carouselMargin = '2em';
    }

    that.displayedImageAsset = displayedImageAsset;
    that.width = that.pageContentMaxWidth;
    that.height = imageHeight * contentScale;
    that.maxWidth = that.pageContentMaxWidth;
    that.carouselMargin = carouselMargin;
  };

  /**
   * Return true if the image asset type is Unsplash.
   *
   * @param {Object} scaledImageAsset Object of scaled image asset.
   * @param {Object} fullImageAsset Object of full image asset.
   * @returns {boolean} true is image is from Unsplash
   */
  this.isUnsplashImage = function isUnsplashImage(scaledImageAsset, fullImageAsset) {
    return ((fullImageAsset && fullImageAsset.source === CONFIG.unsplash.label)
      || (scaledImageAsset && scaledImageAsset.source === CONFIG.unsplash.label));
  };
}
